import { JsonSchemaTypes, RxJsonSchema } from 'rxdb';

export class MigrationSchemaBuilder {
	public constructor(private schema: RxJsonSchema<any>) {}

	public setSchemaVersion(version: number): MigrationSchemaBuilder {
		this.schema = { ...this.schema, version };
		return this;
	}

	public addNewProperty(propertyName: string, propertyType: JsonSchemaTypes) {
		if (this.schema.properties.hasOwnProperty(propertyName)) {
			return this;
		}

		this.schema = {
			...this.schema,
			properties: { ...this.schema.properties, [propertyName]: { type: propertyType } }
		};

		return this;
	}

	public build(): RxJsonSchema<any> {
		return this.schema;
	}
}
